// Node type constants - no dependencies to avoid circular imports
export const NODE_TYPE_KEYS = {
  Start: "start",
  End: "end",
  Delay: "delay",
  RandomNumber: "random_number",
  Check: "check",
  SlackMessage: "SlackMessage",
  Conditional: "split",
  OutboundCall: "start_outbound_call",
  HttpRequest: "http_request",
  SendEmail: "send_email",
  SendSms: "send_sms",
  DataTransform: "data_transform",
  AddContact: "add_contact",
  AddBulkContacts: "add_bulk_contacts",
  CreateContactList: "create_contact_list",
  Ghost: "ghost",
  StartCampaign: "start_campaign",
  CreateCampaign: "create_campaign",
  AddContactToCampaign: "add_contact_to_campaign",
  AddContactsToCampaignBulk: "add_contacts_to_campaign_bulk",
  AddContactToContactList: "add_contact_to_contact_list",
  Chaos: "chaos",
  Agent: "agent",
  RunSkill: "run_skill",
  SubGraph: "sub_graph",
  SubGraphStart: "sub_graph_start",
  SubGraphEnd: "sub_graph_end",
  ForEach: "foreach",
  DocumentAnalysis: "document_analysis",
  JotFormSubmitForm: "jotform_submit_form",
  McpCallTool: "mcp_call_tool",
  SftpUploadFile: "sftp_upload_file",
  SftpDownloadFile: "sftp_download_file",
  SftpListDirectory: "sftp_list_directory",
  GoogleDriveListFiles: "google_drive_list_files",
  GoogleDriveDownloadFile: "google_drive_download_file",
  GoogleDriveUploadFile: "google_drive_upload_file",
  GoogleSheetsAppendRows: "google_sheets_append_rows",
  AgencyZoomSearchCustomers: "agencyzoom_search_customers",
  AgencyZoomGetCustomer: "agencyzoom_get_customer",
  AgencyZoomAddCustomerNote: "agencyzoom_add_customer_note",
  AgencyZoomSearchLeads: "agencyzoom_search_leads",
  AgencyZoomGetLead: "agencyzoom_get_lead",
  AgencyZoomAddLeadNote: "agencyzoom_add_lead_note",
  AgencyZoomSearchTasks: "agencyzoom_search_tasks",
  AgencyZoomCompleteTask: "agencyzoom_complete_task",
  AgencyZoomCreateTask: "agencyzoom_create_task",
  AgencyZoomUpdateTask: "agencyzoom_update_task",
  AgencyZoomCreateLead: "agencyzoom_create_lead",
  AgencyZoomCreateBusinessLead: "agencyzoom_create_business_lead",
  MomentumSearchInsureds: "momentum_search_insureds",
  MomentumGetInsured: "momentum_get_insured",
  MomentumGetPolicy: "momentum_get_policy",
  MomentumAddNote: "momentum_add_note",
  MomentumCreateTask: "momentum_create_task",
  MomentumUpdateTask: "momentum_update_task",
  MomentumSearchTasks: "momentum_search_tasks",
  CreateFile: "create_file",
  ParseCsv: "parse_csv",
  ParseExcel: "parse_excel",
  SliceCsv: "slice_csv",
  CreateCsv: "create_csv",
  GetCallData: "get_call_data",
  DownloadCallRecording: "download_call_recording",
  WebSearch: "web_search",
  WebExtract: "web_extract",
  FillPdfForm: "fill_pdf_form",
  Map: "map",
} as const;

export type NodeTypeKey = typeof NODE_TYPE_KEYS[keyof typeof NODE_TYPE_KEYS];

export const NON_TESTABLE_NODE_TYPES: Set<string> = new Set([
  NODE_TYPE_KEYS.Start,
  NODE_TYPE_KEYS.End,
  NODE_TYPE_KEYS.Conditional,
  NODE_TYPE_KEYS.Check,
  // A single-node test runs the node inside a real start→node→end run, so a
  // Delay actually blocks for its configured duration (capped by the backend's
  // 30s one-off timeout) and returns nothing useful, while variable/CEL delays
  // are rejected outright for one-off runs. Testing it can never succeed in a
  // meaningful way, so it's excluded. (GAIL-188)
  NODE_TYPE_KEYS.Delay,
  NODE_TYPE_KEYS.Ghost,
  NODE_TYPE_KEYS.StartCampaign,
  NODE_TYPE_KEYS.CreateCampaign,
  NODE_TYPE_KEYS.SubGraphStart,
  NODE_TYPE_KEYS.SubGraphEnd,
  NODE_TYPE_KEYS.AddContactToCampaign,
  NODE_TYPE_KEYS.AddContactsToCampaignBulk,
  NODE_TYPE_KEYS.AddContactToContactList,
  NODE_TYPE_KEYS.AddBulkContacts,
  NODE_TYPE_KEYS.Chaos,
  NODE_TYPE_KEYS.SubGraph,
  NODE_TYPE_KEYS.ForEach,
]);

